import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import moment from "moment";

import { monthNameListEN, monthNameListFR } from "Utils/dateUtils.js"
import { checkIfDateIsToday } from "./calendar.utils"

import {
  getFormatFromType,
  getStartAndEndOfFromType,
} from "Components/chartsLibrary/CalendarFilter/calendarUtils.js"

///// STYLES
import {
  Container,
  Arrow,
  Title,
  Content,
  ContainerNumber,
  Number,
  ContainerDatesSelected,
  SubContainerDate,
  IconContainers,
  CloseIcon,
} from "Components/CalendarComponent/index.styles"

const CalendarContent = ({
  title,
  mainColor,
  stepType,
  type,
  preselectedFirstDate,
  preselectedSecondDate,
  dateMinTS,
  dateMaxTS,
  firstDate,
  setFirstDate,
  secondDate,
  setSecondDate,
  disabledMonths,
  disabledDates,
  removeDates,
  setRemoveDates,
  format,
  compared,
  closeCalendar,
  isMobileView,
  language,
  displayMonthFirstLetters,
  partialTrad,
  widthCalendar,
  showIconCalendar,
  showCloseIcon,
  showDatesSelected,
  showTitle,
  highLightTodayDate,
}) => {
  const { TRIMESTER, SEMESTER } = partialTrad || {}

  const getInitialSelectedStep = type => {
    if (firstDate) {
      let formatToUse = getFormatFromType(type)
      if (type === "year") return 2020
      return moment(firstDate, formatToUse).add(1, stepType)
    }

    if (type === "year") return 2020
    return moment()
  }

  const getInitialSelectedStepSub = (type, stepType) => {
    if (firstDate) {
      let formatToUse = getFormatFromType(type)
      if (type === "year") return 2010
      return moment(firstDate, formatToUse)
    }
    if (type === "year") return 2010
    return moment().subtract(1, stepType)
  }

  //STATE
  // example : for type months selectedStep = 2020 and the other is equal to 2019
  const [firstItems, setFirstItems] = useState([]) // left side of the calendar
  const [secondItems, setSecondItems] = useState([]) // right side of the calendar
  const [rerender, setRerender] = useState(false)
  const [selectedStep, setSelectedStep] = useState(getInitialSelectedStep(type))
  const [selectedStepSub, setSelectedStepSub] = useState(
    getInitialSelectedStepSub(type, stepType)
  )

  // useEffect(() => {
  //   setPreselectedDate()
  // }, [])

  useEffect(() => {
    setSelectedStep(getInitialSelectedStep(type))
    setSelectedStepSub(getInitialSelectedStepSub(type, stepType))
    setRerender(true)
  }, [type, stepType])
  /* A rerender state is needed because useState doesn't find the difference between
   * 2 objects so he doesn't rerender automatically
   */

  useEffect(() => {
    if (removeDates) {
      setRemoveDates(false)
      setRerender(true)
    }
  }, [removeDates])

  /*
   * the 2 following useEffect serve to never have a filled second and an empty first
   * they also serve to never have a secondDate superior to the firstDate
   */

  useEffect(() => {
    if (rerender) {
      //first items
      var firstItems = getButtonDateItems(selectedStepSub)
      setFirstItems(firstItems)
      //second items
      var secondItems = getButtonDateItems(selectedStep)
      setSecondItems(secondItems)

      setRerender(false)
    }
  }, [firstDate, secondDate, language, rerender])

  const getNewStep = (previousValue, sign, type, stepType, isFirstValue) => {
    var valueToReturn = previousValue
    if (sign === "+") {
      if (type !== "year") {
        valueToReturn = previousValue.add(1, stepType)
      } else {
        valueToReturn = previousValue + 10
      }
    } else if (sign === "-") {
      if (type !== "year") {
        valueToReturn = previousValue.subtract(1, stepType)
      } else {
        valueToReturn = previousValue - 10
      }
    } else {
      valueToReturn = isFirstValue
        ? getInitialSelectedStepSub(type, stepType)
        : getInitialSelectedStep(type)
    }
    return valueToReturn
  }

  const setNewStepOnPreviousOrNextClick = sign => {
    setSelectedStepSub(previousStep =>
      getNewStep(previousStep, sign, type, stepType, true)
    )
    setSelectedStep(previousStep => getNewStep(previousStep, sign, type, stepType, false))
    setRerender(true)
  }

  const setPreselectedDate = () => {
    if (preselectedFirstDate !== "") {
      let formatPreselected = getFormatFromType(type)
      let startAndEndOf = getStartAndEndOfFromType(type)

      let preselectStep
      let preselectStepSub
      if (type === "year") {
        preselectStep = moment(preselectedFirstDate, formatPreselected).format(
          formatPreselected
        )
        preselectStepSub = moment(preselectedFirstDate, formatPreselected)
          .subtract(1, stepType)
          .format(formatPreselected)
        preselectStep = parseInt(preselectStep) - (parseInt(preselectStep) % 10) + 10
        preselectStepSub = parseInt(preselectStepSub) - (parseInt(preselectStepSub) % 10)
      } else {
        preselectStep = moment(preselectedFirstDate, formatPreselected)
        preselectStepSub = moment(preselectedFirstDate, formatPreselected).subtract(
          1,
          stepType
        )
      }

      setSelectedStep(preselectStep)
      setSelectedStepSub(preselectStepSub)
      setRerender(true)

      let preselectedDateFirstToSet = moment(preselectedFirstDate, formatPreselected)
        .startOf(startAndEndOf)
        .format(formatPreselected)
      setFirstDate(preselectedDateFirstToSet)

      if (preselectedSecondDate !== "") {
        let preselectedDateSecondToSet = moment(preselectedSecondDate, formatPreselected)
          .startOf(startAndEndOf)
          .format(formatPreselected)
        setSecondDate(preselectedDateSecondToSet)
      }
    }
  }

  const onDateClick = date => {
    if (date === firstDate) {
      // remove the last date selected
      setFirstDate(secondDate)
      setSecondDate(null)
    } else if (date === secondDate) {
      //remove secondDate
      setSecondDate(null)
    } else if (firstDate === null && secondDate === null) {
      setFirstDate(date)
      setSecondDate(date)
    } else if (firstDate === null) {
      setFirstDate(date)
    } else {
      setSecondDate(date)
    }

    setRerender(true)
  }

  const isSelected = (dateString, firstDateString, secondDateString) => {
    var selected = false
    if (!dateString || !firstDateString) return false

    if (dateString === firstDateString || dateString === secondDateString) {
      return true
    }

    var formatReceived = getFormatFromType(type)

    var endAndStartOf = getStartAndEndOfFromType(type)

    var startDateTimestamp = 0
    var endDateTimestamp = 0

    startDateTimestamp = firstDateString
      ? moment(firstDateString, formatReceived).startOf(endAndStartOf).format("X")
      : 0
    endDateTimestamp = secondDateString
      ? moment(secondDateString, formatReceived).endOf(endAndStartOf).format("X")
      : 0

    const dateTestedTemp = moment(dateString, formatReceived).startOf(endAndStartOf)
    const dateTested = dateTestedTemp.format("X")

    if (dateTested && startDateTimestamp && endDateTimestamp) {
      selected = startDateTimestamp <= dateTested && dateTested <= endDateTimestamp
    }

    return selected
  }

  const getMonthValue = (language, monthIndex) => {
    switch (language) {
      case "fr":
        return monthNameListFR[monthIndex - 1].substring(0, 3)?.toUpperCase()
      default:
        return monthNameListEN[monthIndex - 1].substring(0, 3)?.toUpperCase()
    }
  }

  const getButtonDateItems = dateObjectConfig => {
    var itemsToReturn = []
    var firstDateString = ""
    var secondDateString = ""
    var valueToDisplay
    var formatWanted = getFormatFromType(type)
    var nbItemToDisplay = getNumberItemToDisplay(type, dateObjectConfig)

    if (type === "year") {
      if (firstDate) firstDateString = `${firstDate}`
      if (secondDate) secondDateString = `${secondDate}`
    } else {
      //month or day
      if (firstDate)
        firstDateString = moment(firstDate, formatWanted).format(formatWanted)
      if (secondDate)
        secondDateString = moment(secondDate, formatWanted).format(formatWanted)
    }

    for (let i = 1; i <= nbItemToDisplay; i++) {
      let beginRunningDate = dateObjectConfig
      //Value to display
      valueToDisplay = i
      if (type === "month" && displayMonthFirstLetters) {
        valueToDisplay = getMonthValue(language, i)
      } else if (type === "year") {
        valueToDisplay = parseInt(beginRunningDate) + i
      } else if (type === "trimester") {
        var firstTrimesterLetter = TRIMESTER.charAt(0)?.toUpperCase()
        valueToDisplay = `${firstTrimesterLetter}${i}`
      } else if (type === "semester") {
        var firstSemesterLetter = SEMESTER.charAt(0)?.toUpperCase()
        valueToDisplay = `${firstSemesterLetter}${i}`
      }

      let dateToUseOnClick = beginRunningDate
      if (type === "year") dateToUseOnClick = `${parseInt(beginRunningDate) + i}`
      else if (type === "month") {
        var year = beginRunningDate.format("YYYY")
        dateToUseOnClick = moment()
          .year(year)
          .month(i - 1)
          .format(formatWanted)
      } else if (type === "trimester") {
        var year = beginRunningDate.format("YYYY")
        var monthNumber = (i - 1) * 3 //0, 3, 6, 9
        var beginOfTrimester = moment().year(year).month(monthNumber).format("MM/YYYY")
        dateToUseOnClick = beginOfTrimester
      } else if (type === "semester") {
        var year = beginRunningDate.format("YYYY")
        var monthNumber = (i - 1) * 6 //0, 6
        var beginOfSemester = moment().year(year).month(monthNumber).format("MM/YYYY")
        dateToUseOnClick = beginOfSemester
      } else {
        dateToUseOnClick = beginRunningDate.date(i).format(formatWanted)
      }

      //disable
      let disabled = false
      // const dateTS = moment(date, "DD MM YYYY").format("X")
      // let disabled = dateTS < dateMinTS || dateTS > dateMaxTS

      // if (stepType === "years") {
      //   const combination = moment(date, "DD MM YYYY").format("MM/YYYY")
      //   disabled = disabledMonths.includes(combination)
      // } else if (stepType === "months") {
      //   disabled = !disabled && disabledDates.includes(date)
      // }

      var dateString = ""
      if (type === "year") {
        dateString = moment(`${dateToUseOnClick}`, "YYYY").format("YYYY")
      } else {
        dateString = dateToUseOnClick
      }

      var selected = isSelected(dateString, firstDateString, secondDateString)
      var isDateOfDay = checkIfDateIsToday(dateString)

      selected = disabled ? false : selected

      itemsToReturn.push(
        <Number
          role="calendarValueDisplayed"
          data-testid={dateString}
          key={i}
          color="#fff"
          backgroundColor={mainColor}
          selected={selected}
          isDateOfDay={highLightTodayDate && isDateOfDay}
          disabled={disabled}
          onClick={!disabled ? () => onDateClick(dateToUseOnClick) : () => {}}
          isYear={type === "year"}
        >
          {valueToDisplay}
        </Number>
      )
    }
    return itemsToReturn
  }

  const getNumberItemToDisplay = (type, momentDateObj) => {
    if (type === "year") return 10
    else if (type === "month") return 12
    else if (type === "day") return momentDateObj.daysInMonth()
    else if (type === "trimester") return 4
    else if (type === "semester") return 2

    return 12
  }

  const isIntegerOrString = content => {
    return typeof content === "string" || typeof content === "number"
  }

  const displayDatesSelected = (firstDate, secondDate) => {
    if (!firstDate || !secondDate) return ""
    const firstDateSplit = firstDate.split("/")
    const secondDateSplit = secondDate.split("/")

    const dateSplitted = {
      firstDateDay: firstDateSplit[0],
      firstDateMonth: firstDateSplit[1],
      firstDateYear: firstDateSplit[2],
      secondDateDay: secondDateSplit[0],
      secondDateMonth: secondDateSplit[1],
      secondDateYear: secondDateSplit[2],
    }

    return (
      <>
        <ContainerDatesSelected style={{ display: "flex", textAlign: "center" }}>
          <SubContainerDate color={mainColor}>
            <p>{dateSplitted.firstDateDay}</p>
            <p>/{dateSplitted.firstDateMonth}</p>
            <p>/{dateSplitted.firstDateYear}</p>
          </SubContainerDate>
          <div>-</div>
          <SubContainerDate>
            <p>{dateSplitted.secondDateDay}</p>
            <p>/{dateSplitted.secondDateMonth}</p>
            <p>/{dateSplitted.secondDateYear}</p>
          </SubContainerDate>
        </ContainerDatesSelected>
        <div style={{ margin: "auto", width: "50%", paddingBottom: "5px" }}></div>
      </>
    )
  }

  return (
    <div
      id="calendarContent"
      {...(compared && {
        style: { backgroundColor: "#F4F4F4", margin: "0 -0.5rem", padding: "0 0.5rem" },
      })}
      role="calendarContent"
    >
      {showTitle && <Title>{title}</Title>}
      {showDatesSelected && displayDatesSelected(firstDate, secondDate)}
      <IconContainers>
        <Arrow
          data-testid="iconPrevious"
          onClick={() => setNewStepOnPreviousOrNextClick("-")}
        >
          <i className="fas fa-arrow-left" />
        </Arrow>
        {showIconCalendar && (
          <Arrow
            data-testid="iconCalendar"
            onClick={() => setNewStepOnPreviousOrNextClick("now")}
          >
            <i className="fas fa-calendar-day" />
          </Arrow>
        )}

        <Arrow
          data-testid="iconNext"
          onClick={() => setNewStepOnPreviousOrNextClick("+")}
        >
          <i className="fas fa-arrow-right" />
        </Arrow>
      </IconContainers>
      {showCloseIcon && (
        <CloseIcon
          data-testid="closeCalendarIcon"
          onClick={closeCalendar}
          color={mainColor}
        >
          <i className="fas fa-times" />
        </CloseIcon>
      )}
      <Content
        isMobileView={isMobileView}
        role="calendarBody"
        widthCalendar={widthCalendar}
      >
        {!isMobileView && (
          <Container style={{ borderRight: "1px solid #000" }}>
            {type === "year" && isIntegerOrString(selectedStepSub) && (
              <strong id="listItemsTitleStepSub"> {selectedStepSub} </strong>
            )}
            {type !== "year" && !isIntegerOrString(selectedStepSub) && (
              <strong id="listItemsTitleStepSub">
                {" "}
                {selectedStepSub.locale(language).format(format)}{" "}
              </strong>
            )}
            <ContainerNumber>{firstItems}</ContainerNumber>
          </Container>
        )}
        <Container>
          {type === "year" && isIntegerOrString(selectedStep) && (
            <strong id="listItemsTitleStep"> {selectedStep} </strong>
          )}
          {type !== "year" && !isIntegerOrString(selectedStep) && (
            <strong id="listItemsTitleStep">
              {" "}
              {selectedStep.locale(language).format(format)}{" "}
            </strong>
          )}
          <ContainerNumber>{secondItems}</ContainerNumber>
        </Container>
      </Content>
    </div>
  )
}

CalendarContent.propTypes = {
  type: PropTypes.oneOf(["year", "month", "day", "trimester", "semester"]),
  displayMonthFirstLetters: PropTypes.bool,
  showTitle: PropTypes.bool,
  showCloseIcon: PropTypes.bool,
  showIconCalendar: PropTypes.bool,
}

CalendarContent.defaultProps = {
  displayMonthFirstLetters: false,
  type: "day",
  showTitle: true,
  showCloseIcon: true,
  showIconCalendar: true,
}

export default CalendarContent
